//@ts-nocheck
import { Fragment, useEffect, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import Modal from "../common/Modal";
import { useAppDispatch } from "../../app/hooks";
import { createTeamsPayload } from "../../features/scorecard/scoreCardTypes";
import { toast } from "sonner";
import {
  createLocation,
  fetchScoreCardPipelineDetailsData,
  updateLocation,
} from "../../features/scorecard/scoreCardSlice";
import {
  ChevronDownIcon,
  ChevronDownIconWhite,
  CustomCheckIcon,
  XCircleColorIcon,
} from "../icons";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { fetchJobPipelineDetailsAssign } from "../../features/pipeline/pipelineSlice";
import { useParams } from "react-router-dom";
interface BoardPageProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  editBoardData?: any;
  baseId: number;
  setEditBoardData: (value: any) => void;
}

const CreateStagesScoreDetails: React.FC<BoardPageProps> = ({
  isModalOpen,
  setIsModalOpen,
  editBoardData,
  setEditBoardData,
}) => {
  const [name, setName] = useState("");
  const [purpose, setPurpose] = useState("");
  const [color, setColor] = useState("bg-[#3b82f6]");
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState("");
  const [purposeError, setPurposeError] = useState("");
  const dispatch = useAppDispatch();
  const userStatus = localStorage.getItem("userDetails");
  const userStatusId = userStatus ? JSON.parse(userStatus) : null;
  const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
  const { jobId } = useParams<{ jobId: string }>();
  const { baseId } = useParams<{ baseId: string }>();
  const [selectedStage, setSelectedStage] = useState<any>(null);
  const [availableStages, setAvailableStages] = useState<any[]>([]);

  const colorList = [
    { name: "bg-[#3b82f6]" },
    { name: "bg-[#6b7280]" },
    { name: "bg-[#bfdbfe]" },
    { name: "bg-[#ec4899]" },
    { name: "bg-[#6366f1]" },
    { name: "bg-[#eab308]" },
    { name: "bg-[#22c55e]" },
    { name: "bg-[#06b6d4]" },
    { name: "bg-[#dc2626]" },
  ];

  // Load edit data when available
  useEffect(() => {
    if (editBoardData) {
      setName(editBoardData.scorecard_name || "");
      setPurpose(editBoardData.scorecard_description || "");
      setColor(`bg-[${editBoardData.scorecard_colour}]` || "bg-[#3b82f6]");
      // setChecked(editBoardData.ai_check === 'yes');
      // setSelectedStage(editBoardData.stage_id);
    }
  }, [editBoardData]);

  useEffect(() => {
    const storedData = localStorage.getItem("baseScoreCardDataByJob");
    if (storedData) {
      setBaseTeamsData(JSON.parse(storedData));
    }
  }, []);

  const handleSave = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setNameError("");
    setPurposeError("");

    if (name.trim().length === 0) {
      setNameError("Name is required");
      setLoading(false);
      return;
    }
    const colorValue = color.substring(
      color.indexOf("[#") + 1,
      color.indexOf("]"),
    );

    const payload: createTeamsPayload = {
      base_id: baseId,
      scorecard_name: name,
      scorecard_description: purpose,
      scorecard_colour: colorValue,
      // ai_check: privacy,
      stage_id: selectedStage ? [selectedStage.id].toString() : [],
      job_id: jobId,
    };

    try {
      if (editBoardData) {
        // Update existing team
        const response = await dispatch(
          updateLocation({
            payload,
            userId: baseId,
            id: editBoardData.id,
          }),
        );

        if (response.meta.requestStatus === "fulfilled") {
          toast.success("Scorecard updated successfully!");
        } else {
          toast.error("Failed to update team.");
        }
      } else {
        // Create new team
        const response = await dispatch(
          createLocation({ payload, userId: baseId }),
        );
        if (response.meta.requestStatus === "fulfilled") {
          toast.success("Scorecard created successfully!");
        } else {
          toast.error("Failed to create team.");
        }
      }

      setIsModalOpen(false);
      resetForm();

      // Fetch updated list
      const baseResponse = await dispatch(
        fetchScoreCardPipelineDetailsData({
          baseId: Number(baseId),
          JobId: jobId,
        }),
      );
      if (baseResponse?.payload) {
        localStorage.setItem(
          "baseScoreCardDataByJob",
          JSON.stringify(baseResponse.payload),
        );
        window.dispatchEvent(
          new StorageEvent("storage", {
            key: "baseScoreCardDataByJob",
            newValue: JSON.stringify(baseResponse.payload),
          }),
        );
      }
    } catch (error) {
      console.error("Failed to save team:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setName("");
    setPurpose("");
    setColor("bg-[#3b82f6]");
    // setChecked(false);
    setEditBoardData(null); // Add this line
    setSelectedStage(null);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "name") {
      setName(value);
      setNameError(value.trim().length === 0 ? "Name is required" : "");
    } else if (name === "purpose") {
      setPurpose(value);
      // setPurposeError(value.trim().length === 0 ? "Description is required" : "");
    }
  };

  // Modified useEffect to only fetch pipeline stages when 'member' role is selected
  // Modify the useEffect for fetching pipeline stages
  useEffect(() => {
    const fetchPipelineStages = async () => {
      try {
        const response = await dispatch(
          fetchJobPipelineDetailsAssign({
            baseId: parseInt(baseId, 10),
            userId: userStatusId?.id,
            JobId: jobId,
          }),
        ).unwrap();

        const formattedStages =
          response.data.stages?.map((stage: any) => ({
            id: stage.id,
            name: stage.stage_name,
            color: stage.stage_colour,
            bucket: stage.bucket,
          })) || [];

        setAvailableStages(formattedStages);

        // If editing, set selected stages from editBoardData
        if (editBoardData && editBoardData.stages) {
          setSelectedStages(editBoardData.stages);
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch pipeline stages");
      }
    };

    fetchPipelineStages();
  }, [dispatch, baseId, jobId, userStatusId?.id, editBoardData]);

  // Add handler for stage selection
  const handleStageSelect = (stage: any) => {
    setSelectedStage(stage);
  };

  // Handle stage removal
  const handleRemoveStage = () => {
    setSelectedStage(null);
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => {
        setIsModalOpen(false);
        resetForm();
      }}
      title={editBoardData ? "Edit Scorecard" : "Create Scorecard"}
      onSave={handleSave}
      loading={loading}
    >
      <form action="#" onSubmit={handleSave} className="space-y-6 mt-5">
        <div className="flex flex-col gap-y-2">
          <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
            Name
          </label>
          <div className="relative">
            <Menu as="div" className="flex items-center">
              <Menu.Button className="absolute inset-y-0 left-0 flex items-center px-2">
                <div
                  className={`h-6 w-6 rounded-full ${color} border flex justify-center items-center`}
                >
                  <ChevronDownIconWhite />
                </div>
              </Menu.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                  {colorList.map((value, index) => (
                    <div
                      onClick={() => setColor(value.name)}
                      key={index}
                      className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center cursor-pointer`}
                    >
                      {color === value.name && <CustomCheckIcon />}
                    </div>
                  ))}
                </Menu.Items>
              </Transition>
              <input
                id="name"
                name="name"
                type="text"
                value={name}
                onChange={handleInputChange}
                placeholder="Enter Name"
                className="w-full px-4 py-2 pl-10 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
              />
            </Menu>
          </div>
          {nameError && <p className="text-sm text-red-600">{nameError}</p>}

          <div className="flex flex-col gap-y-2 mt-1">
            <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
              Description
            </label>
            <input
              id="purpose"
              name="purpose"
              type="text"
              value={purpose}
              onChange={handleInputChange}
              placeholder="Team description"
              className="w-full px-4 py-2 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            />
            {purposeError && (
              <p className="text-sm text-red-600">{purposeError}</p>
            )}
          </div>

          <div className="mt-4">
            <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
              Add stages
            </label>

            {/* Selected Stages Chips */}
            <div className="flex flex-wrap gap-2 mb-2">
              {selectedStage && (
                <div className="flex flex-wrap gap-2 mb-2">
                  <div className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 text-sm">
                    <span
                      className="w-2 h-2 rounded-full"
                      style={{ backgroundColor: selectedStage.color }}
                    ></span>
                    {selectedStage.name}
                    <button
                      type="button"
                      onClick={handleRemoveStage}
                      className="text-indigo-500 hover:text-indigo-700"
                    >
                      <XCircleColorIcon className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Stages Dropdown */}
            <Listbox value={selectedStage} onChange={handleStageSelect}>
              <div className="relative mt-1">
                <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                  <span className="block truncate">
                    {selectedStage ? selectedStage.name : "Select stage"}
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <ChevronDownIcon className="h-5 w-5 text-gray-400" />
                  </span>
                </ListboxButton>

                <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {availableStages.length === 0 ? (
                    <div className="px-4 py-2 text-sm text-gray-500">
                      There are no stages here
                    </div>
                  ) : (
                    availableStages.map((stage) => (
                      <ListboxOption
                        key={stage.id}
                        value={stage}
                        className={({ active }) =>
                          `relative cursor-pointer select-none py-2 pl-3 pr-9 ${
                            active ? "bg-indigo-50" : ""
                          }`
                        }
                      >
                        {({ selected, active }) => (
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-x-2">
                              <span
                                className="shrink-0 w-[9px] h-[9px] block rounded-full"
                                style={{ background: stage.color }}
                              />
                              <span
                                className={`block truncate ${selected ? "font-semibold" : "font-normal"}`}
                              >
                                {stage.name}
                              </span>
                            </div>
                            {selected && (
                              <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-indigo-600">
                                <CustomCheckIcon className="h-5 w-5" />
                              </span>
                            )}
                          </div>
                        )}
                      </ListboxOption>
                    ))
                  )}
                </ListboxOptions>
              </div>
            </Listbox>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default CreateStagesScoreDetails;
